<template>
    <div class="year-total-money">
        <van-nav-bar
            title="款"
            left-text=""
            left-arrow
            @click-left="onClickLeft"
            @click-right="showFilterPop = true"
        >
            <template #title>
                <img class="nav_title" src="../../../assets/images/leadingCockpit/kuan_nav.png">
            </template>
            <template #right>
                <img class="shaixuan" src="../../../assets/images/leadingCockpit/shaixuan.png">
            </template>
        </van-nav-bar>
        <div class="container-wrapper">
            <filterRadio
                :show-filter-pop.sync="showFilterPop"
                :date="date"
                @sureBack="sureBack"
            ></filterRadio>
            <div class="data-box">
                <div class="data-item left">
                    <p>
                        本月余额(万元)：<span>{{ info.current_month_balance_total }}</span>
                    </p>
                    <p>
                        年初余额(万元)：<span>{{ info.beginning_year_balance_total }}</span>
                    </p>
                    <p>
                        年初比(万元)：<span>{{ info.beginning_year_ratio_total }}</span>
                    </p>
                </div>
                <div class="data-item right">
                    <p>
                        本月货款回收率：<span>{{ info.month_rate_recovery_total }}</span>
                    </p>
                    <p>
                        本年货款回收率：<span>{{ info.year_rate_recovery_total }}</span>
                    </p>
                </div>
            </div>
            <!--            <div class="charts_header">-->
            <!--                <van-tabs-->
            <!--                    type="card"-->
            <!--                    color="#3495FB"-->
            <!--                    v-model="tabActive"-->
            <!--                    @click="tabSelect"-->
            <!--                >-->
            <!--                    <template v-for="(item,index) in tabData">-->
            <!--                        <van-tab :key="index" :title="item.name"></van-tab>-->
            <!--                    </template>-->
            <!--                </van-tabs>-->
            <!--            </div>-->
            <div class="charts-panel" v-show="listData.length>0">
                <div id="balance-chart" class="charts-box">
                </div>
            </div>
            <div class="bg-line"></div>
            <div class="charts-panel" v-show="listData.length>0">
                <h2 class="title">
                    本月余额
                </h2>
                <div id="recovery-chart" class="charts-box ">
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import filterRadio from './filterConditions/filterRadio';
import utils from '@/assets/js/utils';
export default {
    name: 'year-total-money',
    components: { filterRadio },
    data() {
        return {
            info: {
                current_month_balance_total: 0,
                beginning_year_balance_total: 0,
                beginning_year_ratio_total: 0,
                month_rate_recovery_total: 0,
                year_rate_recovery_total: 0,
            }, // 数据信息
            listData: [], // 列表数据
            // 当前日期
            date1: '',
            date2: '',
            // tab选项
            tabData: [{
                name: '按销售公司',
                val: 1,
            }],
            // tab默认值
            tabActive: 0,
            showFilterPop: false,
            filterParams: {},
            date: {
                startDate: '',
                endDate: '',
            },
        };
    },
    created() {
        const curDate = new Date();
        const beginDate = new Date(curDate.getFullYear(), 0);
        const endDate = new Date();
        this.date.startDate = utils.timeFormat(beginDate, 'yyyy-MM').substr(0, 7);
        this.date.endDate = utils.timeFormat(endDate, 'yyyy-MM').substr(0, 7);
        this.filterParams = Object.assign({}, this.date);
        this.filterParams.pian_q_id = '';
    },
    mounted() {
        this.getData();
    },
    methods: {
        tabSelect() {
            this.getData();
        },
        // 获取全部合同应收
        getData() {
            const path = '/interfaceApi/report/leadercockpit/get_year_accounts_receivable_data_app?pian_q_id=' + this.filterParams.pian_q_id || '';
            return this.$axios.get(path).then(res => {
                if (res) {
                    this.info.current_month_balance_total = (res.current_month_balance_total / 10000).toFixed(2);
                    this.info.beginning_year_balance_total = (res.beginning_year_balance_total / 10000).toFixed(2);
                    this.info.beginning_year_ratio_total = (res.beginning_year_ratio_total / 10000).toFixed(2);
                    this.info.month_rate_recovery_total = res.month_rate_recovery_total + '%';
                    this.info.year_rate_recovery_total = res.year_rate_recovery_total + '%';
                    this.listData = res.list || [];

                    this.$nextTick(() => {
                        this.lineColumn('balance-chart');
                        this.pieChart('recovery-chart');
                    });
                } else {
                    this.info = Object.assign({}, this.$options.data().info);
                    this.listData = [];
                }
            });
        },
        sureBack(pamams) {
            this.filterParams = pamams;
            this.getData();
        },
        lineColumn(obj) {
            const data = {
                xAxis: [],
                list1: [], // 年度累计应收
                list2: [], // 年度累计实收
                list3: [], // 本年货款回收率
            };

            this.listData.forEach(item => {
                data.xAxis.push(item.show_name);
                data.list1.push((item.year_accumulated_accounts_receivable / 10000).toFixed(2));
                data.list2.push((item.year_accumulated_net_receipts / 10000).toFixed(2));
                data.list3.push(item.year_rate_recovery);
            });
            const lineColumnChart = window.$globalHub.$echarts.init(document.getElementById(obj));
            const option = {
                title: {
                    text: '货款回收率',
                    left: 'left',
                    textStyle: {
                        color: '#ffffff',
                        fontSize: 16,
                    },
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow',
                        label: {
                            show: true,
                        },
                    },
                },
                legend: {
                    textStyle: {
                        color: 'rgba(255,255,255,0.5)',
                        fontSize: 10,
                    },
                    top: 30,
                },
                grid: {
                    left: 40,
                    top: 90,
                    right: 40,
                    bottom: 40,
                },
                xAxis: [{
                    // type:'category',
                    data: data.xAxis,
                    boundaryGap: true,
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: 'rgba(133,133,133,0.2)',
                        },
                    },
                    splitArea: {
                        color: '#f00',
                        lineStyle: {
                            color: '#f00',
                        },
                    },
                    axisLabel: {
                        color: '#979EA7',
                        interval: 0,
                        rotate: -45, // 倾斜度 -90 至 90 默认为0
                        textStyle: {
                            fontSize: '10',
                        },
                    },
                    splitLine: {
                        show: false,
                    },
                    axisTick: {
                        show: false,
                    },
                }],
                yAxis: [
                    {
                        name: '(万元)',
                        nameLocation: 'end',
                        nameTextStyle: {
                            color: '#979EA7',
                            padding: '',
                        },
                        splitLine: {
                            show: true,
                            lineStyle: {
                                color: 'rgba(255,255,255,0.1)',
                                width: 0.5,
                                type: 'dashed',
                            },
                        },
                        axisLine: {
                            show: true,
                            lineStyle: {
                                color: 'rgba(133,133,133,0.2)',
                            },
                        },
                        axisLabel: {
                            show: true,
                            color: '#979EA7',
                        },
                        axisTick: {
                            show: false,
                        },
                    },
                    {
                        name: '(%)',
                        nameLocation: 'end',
                        nameTextStyle: {
                            color: '#979EA7',
                            padding: '',
                        },
                        splitLine: {
                            show: true,
                            lineStyle: {
                                color: 'rgba(133,133,133,0.2)',
                                width: 0.5,
                                type: 'solid',
                            },
                        },
                        axisLine: {
                            show: true,
                            lineStyle: {
                                color: 'rgba(133,133,133,0.2)',
                            },
                        },
                        axisLabel: {
                            show: true,
                            color: '#979EA7',
                        },
                        axisTick: {
                            show: false,
                        },
                    },
                ],
                series: [
                    {
                        name: '年度累计应收',
                        barWidth: 15,
                        type: 'bar',
                        itemStyle: {
                            normal: {
                                color: new window.$globalHub.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                    offset: 0,
                                    color: '#55A7FE',
                                },
                                {
                                    offset: 1,
                                    color: '#3E79C5',
                                },
                                ]),
                            },
                        },
                        data: data.list1,
                    },
                    {
                        name: '年度累计实收',
                        type: 'bar',
                        barWidth: 15,
                        yAxisIndex: 0,
                        stack: '总累计实收',
                        itemStyle: {
                            normal: {
                                color: new window.$globalHub.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                    offset: 0,
                                    color: '#EFAB54',
                                },
                                {
                                    offset: 1,
                                    color: '#FA8C47',
                                },
                                ]),
                            },
                        },
                        data: data.list2,
                    },
                    {
                        name: '本年货款回收率',
                        type: 'line',
                        // smooth: true,
                        showSymbol: true,
                        symbolSize: 8,
                        lineStyle: {
                            normal: {
                                color: '#21BC9A',
                                width: 2,
                            },
                        },
                        yAxisIndex: 1,
                        label: {
                            show: false,
                            position: 'top',
                            textStyle: {
                                color: '#FC9343',
                            },
                        },
                        itemStyle: {
                            color: '#6c50f3',
                            borderColor: '#fff',
                            borderWidth: 2,
                            shadowColor: 'rgba(0, 128, 100, 0.5)',
                            shadowBlur: 0,
                            shadowOffsetY: 2,
                            shadowOffsetX: 2,
                            normal: {
                                color: '#21BC9A',
                                lineStyle: {
                                    color: '#21BC9A',
                                },
                            },
                        },
                        data: data.list3,
                    },
                ],
            };
            lineColumnChart.setOption(option);
        },

        pieChart(obj) {
            const chart = window.$globalHub.$echarts.init(document.getElementById(obj));
            // 默认四种渐变颜色
            const colors = [
                ['#76E0A8', '#13BD63'],
                ['#71C6B0', '#4EA496'],
                ['#48A0D8', '#7FD0FE'],
                ['#F79187', '#EA5D5D']];


            const data = [];
            this.listData.forEach(item => {
                data.push({
                    name: item.show_name,
                    value: item.current_month_balance,
                });
            });
            let total = 0;
            data.forEach(item => {
                total += item.value;
            });
            data.forEach(item => {
                item.name += '(' + (item.value / total * 100).toFixed(1) + '%)';
                item.value = (item.value / 10000).toFixed(2);
            });
            const result = [];
            data.forEach((item, index) => {
                const obj = {
                    value: item.value,
                    name: item.name,
                    label: {
                        alignTo: 'edge',
                        formatter: '{name|{b}} \n{value|{c}万}',
                        minMargin: 5,
                        edgeDistance: 5,
                        lineHeight: 18,
                        rich: {
                            name: {
                                fontSize: 11,
                                color: 'rgba(255,255,255,0.7)',
                            },
                            value: {
                                fontSize: 11,
                                color: 'rgba(255,255,255,0.7)',
                            },
                        },
                    },
                };
                if (index < colors.length) {
                    obj.itemStyle = {
                        color: {
                            type: 'linear',
                            x: 0,
                            y: 0,
                            x2: 0,
                            y2: 1,
                            colorStops: [{
                                offset: 0, color: colors[index][0], // 0% 处的颜色
                            }, {
                                offset: 1, color: colors[index][1], // 100% 处的颜色
                            }],
                            global: false, // 缺省为 false
                        },
                    };
                }
                result.push(obj);
            });
            const option = {
                series: [
                    {
                        type: 'pie',
                        radius: '45%',
                        center: ['50%', '50%'],
                        selectedMode: 'single',
                        data: result,
                        labelLayout: function (params) {
                            const isLeft = params.labelRect.x < chart.getWidth() / 2;
                            const points = params.labelLinePoints;
                            // Update the end point.
                            points[2][0] = isLeft
                                ? params.labelRect.x
                                : params.labelRect.x + params.labelRect.width;

                            return {
                                labelLinePoints: points,
                            };
                        },
                        emphasis: {
                            show: false,
                        },
                    },
                ],
            };
            chart.setOption(option);
        },
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        // 跳转页面
        to(path) {
            this.$router.isBack = 2;
            this.$router.push({ name: path });
        },
    },
};
</script>
<style scoped lang="stylus">
$bgLineLeft = url("../../../assets/images/leadingCockpit/frame_blue_left.png") left no-repeat
$bgLineRight = url("../../../assets/images/leadingCockpit/frame_blue_right.png") right no-repeat
$bgLineOrangeLeft = url("../../../assets/images/leadingCockpit/frame_orange_left.png") left no-repeat
$bgLineOrangeRight = url("../../../assets/images/leadingCockpit/frame_orange_right.png") right no-repeat
    .year-total-money
        background url('../../../assets/images/leadingCockpit/bg.png') #0E1C31
        background-size 100%
        padding-bottom 20rpx;
        .van-nav-bar
            background #001F4C!important;
            .shaixuan
                width 18rpx;
        .nav_title
            margin-top 10rpx
            width 52rpx;
        .charts_header
            margin 12rpx 30rpx
            >>> .van-tabs__nav
                margin 0
                background transparent;
        .container-wrapper
            height calc(100% - 20rpx)
            overflow-y auto
        .bg-line
            height 15rpx;
            background rgba(0,0,0,0.3);
        .filterConditions
            display flex
            width 94%;
            height 40rpx
            padding 15rpx 10rpx
            width: 94%;
            margin: 13rpx auto 0;
            background url("../../../assets/images/leadingCockpit/bg_secondary_page_1.png") no-repeat center
            background-size 100%
            justify-content center
            align-items center
            .line
                width: 20rpx;
                height: 2px;
                background: rgba(255, 255, 255, 0.2);
            .time
                width 80rpx
                height 30rpx
                line-height 28rpx
                margin 0 5rpx
                position relative
                input
                    width 130rpx
                    height 30rpx
                    border none
                    text-indent 30rpx
                    background: transparent;
                    font-size 14rpx;
                    color:#fff;
                    font-family: Technology-Regular, Technology;
                &:before
                    line-height 30rpx
                    font-size 16rpx
                    color #0096F8
                    position absolute
                    left 5rpx
        .data-box
            display flex
            justify-content space-between
            padding 15rpx;
            .data-item
                font-size 12rpx;
                color #fff;
                width: 165rpx;
                height: 126rpx;
                background: #12243D;
                border: 1px solid #27436C;
                p
                    white-space nowrap;
                    padding-left 10rpx;
                &.left
                    p
                        height 33%;
                        display flex
                        align-items center
                        &:nth-child(2)
                            border-top 1px dashed #27436C
                            border-bottom 1px dashed #27436C
                        span
                            font-size: 18px;
                            font-family: Technology-Regular, Technology;
                            color: #03B0FE;
                &.right
                    p
                        height 50%;
                        display flex
                        align-items center
                        &:nth-child(1)
                            border-bottom 1px dashed #27436C
                        span
                            font-size: 18px;
                            font-family: Technology-Regular, Technology;
                            color: #FDDC24;
        .charts-panel
            padding 15rpx;
            .title
                padding-left 4rpx;
                font-size 16rpx;
                color:#fff;
                font-weight bold
            .charts-box
                padding-top 10rpx;
                height 250rpx;
            #balance-chart
                padding-top 0
</style>
